import React from 'react';
import { connect } from 'react-redux';
import Textfield from '@cybs-ui/components/lib/textfield';
import { putDataInDevCenterDataStore, getDevCenterDataStore } from '../../../../../app/store';
import { getHasQueryParams, getLiveConsoleTabIndex } from '../../../reducers/rhs-schema-reducer';


/**
 * Request description in live console tab 
 */
var hasQueryParams = getHasQueryParams();
var queryParams = [];
var queryParamsCurrentValues = {};
var liveConsoleTabIndex = getLiveConsoleTabIndex();
var counter = 0;
var urlCounter = 0;
class QueryParamsTabInLiveConsole extends React.Component {

    queryParamChecker = getDevCenterDataStore().subscribe(() => {

        if (this.props.liveConsoleTabIndex == 2 && this.props.hasQueryParams == true) {
            this.setState({ comment: 'Force render for Query Params two-way binding' });
        }

    });
    render() {
        return (
            <div id="queryParamsTab" style={{ paddingLeft: 16 }}>
                {
                 
                    this.props.hasQueryParams &&
                    this.props.queryParams.map((queryParam,index) => {
                        return (
                            <div style={{ marginLeft: '30%' }}>
                                <Textfield
                                    className="text-field-mock"
                                    i18n={{ label: queryParam.name }}
                                    required={queryParam.required}
                                    width='300px'
                                    value={this.props.queryParamsCurrentValues[queryParam.name] ? this.props.queryParamsCurrentValues[queryParam.name] : ''}
                                    key = {this.props.queryParams.indexOf(queryParam) + index}
                                    onFocus={() => { }}
                                    onBlur={e => { }}
                                    id={'textfield' + this.props.queryParams.indexOf(queryParam)}
                                    onChange={(e) => {
                                        var inputBox = document.getElementById('textfield' + this.props.queryParams.indexOf(queryParam));
                                        this.props.queryParamsCurrentValues[queryParam.name] = inputBox.value;
                                        putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMS_CONTROL', queryParamsControl: 'liveConsole' });
                                        putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES', queryParamsCurrentValues: this.props.queryParamsCurrentValues });
                                        putDataInDevCenterDataStore({ type: 'UPDATE_URL_PARAMETERS_COUNTER', urlCounter: (++urlCounter)});
                                    }}
                                    
                                />
                            </div>

                        )
                    })
                }
            </div>
        );

    }
}
function mapStateToProps(state) {
    liveConsoleTabIndex = (state.rhsReducer.liveConsoleTabIndex == undefined) ? 0 : state.rhsReducer.liveConsoleTabIndex;
    hasQueryParams = (state.rhsReducer.hasQueryParams == undefined) ? false : state.rhsReducer.hasQueryParams;
    queryParamsCurrentValues = (state.rhsReducer.queryParamsCurrentValues == undefined) ? {} : state.rhsReducer.queryParamsCurrentValues;
    counter = state.rhsReducer.queryParametersCounter;
    // var queryParamsCurrentValuesCopy = queryParamsCurrentValues;
    // putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES', queryParamsCurrentValues: {} });
    // putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES', queryParamsCurrentValues: queryParamsCurrentValuesCopy });
    queryParams = (state.rhsReducer.queryParameters == undefined) ? [] : state.rhsReducer.queryParameters;
    return {
        hasQueryParams: hasQueryParams,
        queryParamsCurrentValues: queryParamsCurrentValues,
        queryParams: queryParams,
        liveConsoleTabIndex : liveConsoleTabIndex,
        counter :counter
    };

}

export default connect(mapStateToProps)(QueryParamsTabInLiveConsole);